import React from "react"

export default function AustrianFlag({className}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 900 600">
      <defs />
      <path fill="#ed2939" d="M0 0h900v600H0z" />
      <path fill="#fff" d="M0 200h900v200H0z" />
    </svg>
  )
}
